import React from 'react';
import { Box, Button, Grid, Tooltip, Typography } from '@mui/material';
import { Form } from 'formik';
import * as Yup from 'yup';
import { MuiForm } from 'lib/Form';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { MuiFormLabel } from 'lib/form/MuiFormLabel';
import { LoadingButton } from 'ui/buttons/LoadingButton';
import { Row } from 'ui/Flex';
import { Throbber } from 'ui/Throbber';

export interface CampaignDefineFormData {
    title: string;
    description?: string;
}

interface CreateCampaignDefineProps {
    onSubmit: (values: CampaignDefineFormData) => void;
    open: boolean;
    initialValues?: CampaignDefineFormData;
    isLoading?: boolean;
    isCampaignExist?: boolean;
}

const defaultValues: CampaignDefineFormData = {
    title: '',
    description: ''
};

const validationSchema = Yup.object().shape({
    title: Yup.string().required('This field is required.')
});

export const CreateCampaignDefine: React.FC<CreateCampaignDefineProps> = ({
    onSubmit,
    isLoading,
    open,
    initialValues,
    isCampaignExist
}) => {
    if (!open) {
        return null;
    }
    if (isCampaignExist && !initialValues) {
        return <Throbber />;
    }
    return (
        <MuiForm
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            initialValues={initialValues || defaultValues}
        >
            {({ submitForm, isValid }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box padding={3} maxWidth={600}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h4" color="secondary">
                                            1. Define
                                        </Typography>
                                        <Typography variant="body2">
                                            These settings are only visible to yourself
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextFormField
                                            name="title"
                                            label={<MuiFormLabel required>Name</MuiFormLabel>}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextFormField
                                            name="description"
                                            multiline
                                            maxRows={3}
                                            label="Description"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box padding={3} paddingRight={0}>
                                            <Row flex={1} align="flex-end" gutter>
                                                {!isValid && (
                                                    <Tooltip title="Give your Campaign a name in order to save or continue">
                                                        <div>
                                                            <Button
                                                                disabled
                                                                onClick={submitForm}
                                                                color="primary"
                                                                variant="contained"
                                                            >
                                                                Save and Continue
                                                            </Button>
                                                        </div>
                                                    </Tooltip>
                                                )}
                                                {isValid && (
                                                    <LoadingButton
                                                        loading={isLoading}
                                                        disabled={isLoading}
                                                        onClick={submitForm}
                                                        color="primary"
                                                        variant="contained"
                                                    >
                                                        Save and Continue
                                                    </LoadingButton>
                                                )}
                                            </Row>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </MuiForm>
    );
};
